import React from "react";
import gimage from "../../assets/g-logo.webp";

const Login = ({ setShowModal, showModal }) => {
  return (
  <div>
    <div
      className="flex justify-center items-center md:w-full backdrop-blur-[1px] bg-black/40 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
      <div className="relative my-6 flex mx-auto max-w-3xl">
        <div className="border-0 rounded-lg shadow-lg relative flex flex-col lg:w-96 bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 rounded-t ">
            <h3 className="text-1xl font-semibold mx-auto">Login now</h3>
          </div>
          <div class="md:w-12/12 lg:w-12/12 mx-10 mb-5 mt-2">
            <form>
              <div class="mb-2">
                <label for="formFileDisabled" class="form-label text-sm inline-block text-gray-700">Email</label>
                <input
                  type="text"
                  class="form-control bg-gray-100 block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="email or phone number"
                />
              </div>

              <div class="mb-6">
                <label for="formFileDisabled" class="form-label  text-sm inline-block text-gray-700">Password</label>
                <input
                  type="password"
                  class="form-control bg-gray-100 block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  placeholder="Password"
                />
              </div>

              <div class="flex justify-between items-center mb-6">
                <div class="form-group form-switch">
                  <input checked class="form-check-input appearance-none w-9 rounded-full float-left h- align-top bg-white bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm" type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                  <label class="form-check-label inline-block text-gray-800 text-xs" for="exampleCheck2"
                  >Remember me</label>
                </div>
                <div
                  
                  class="text-[#CE102C] text-xs hover:text-[#CE102C] focus:text-[#CE102C] active:text-blue-800 duration-200 transition ease-in-out"
                  onClick={() => {
                  setShowModal(3);
                }}>
                Forgot password?</div>
              </div>

              <button
                // type="submit"
                class="inline-block px-7 py-3 bg-[#CE102C] text-white font-medium text-sm leading-snug uppercase rounded-full shadow-md hover:bg-[#CE102C] hover:shadow-lg focus:bg-[#CE102C] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#CE102C] active:shadow-lg transition duration-150 ease-in-out w-full"
                data-mdb-ripple="true"
              
  
                data-mdb-ripple-color="light"
              >
                Sign in
              
              </button>

              <div
                class="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5"
              >
                <p class="text-center font-semibold mx-4 mb-0">OR</p>
              </div>


              <a
                class="px-7 py-3 text-white font-medium text-sm  leading-snug uppercase rounded-full shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out w-full flex justify-center items-center"
                style={{ backgroundColor: "black" }}
                href="#!"
                role="button"
                data-mdb-ripple="true"
                data-mdb-ripple-color="light"
                onClick={() => showModal(false)}
              >
                <img src={gimage} width="20" style={{ marginRight: 15 }} alt="a" />
                Continue with Google
              </a>
              <div className="flex items-start justify-between pb-2 rounded-t ">
                <span className="text-xs mx-auto mt-8">Don't have account now? <span class="text-[#CE102C] font-semibold hover:text-[#CE102C] focus:text-[#CE102C] active:text-blue-800 duration-200 transition ease-in-out"  href="#!" 
                onClick={() => {
                  setShowModal(2);
                }}>
                  Sign up now </span></span>
              </div>

            </form>
          </div>
        </div>
        <div className="">
          <div className="bg-white ml-4 rounded-2xl" onClick={() => setShowModal(0)}>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    </div>
    )
}

export default Login